import styled from 'styled-components';

import { Grid, Paper } from '@mui/material';

export const PieChartGrid = styled(Grid)`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    justify-content: space-between;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
`;

export const NoData = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    color: #999;
    font-size: 14px;
`;

export const TitleGrid = styled(Grid)`
    padding: 1rem 2rem 0 2rem;
    background-color: white;
`;

export const PaperContainer = styled(Paper)`
    display: flex;
    flex-direction: column;
    align-items: ${({ center }) => (center ? 'center' : 'flex-start')};
    /* justify-content: ${({ justify }) => justify ?? 'space-evenly'}; */
    padding: 24px;
    gap: 15px;
    width: 100%;
    height: ${({ height }) => height ?? '140px'};

    box-shadow: 0px 3px 12px rgba(81, 69, 159, 0.08);
    border-radius: 15px;
`;

export const ContainerYears = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const Div = styled.div`
    width: ${({ width }) => width ?? '6.5rem'};
    display: flex;
    align-items: center;
    gap: 1.25rem;
    justify-content: space-between;

    > p {
        font-size: 20px;
    }
`;
